export default "__VITE_ASSET__BXtVHnGU__"